
import productos from '../../lensun principal/principla/len';
import "./headerlensun.css"

function LensunHeader(){
    return(
        <div>
          <header class="bg  py-5">
            <div class="container px-4 px-lg-5 my-5">
                <div class="text-center text-white">
                 <a href='/lensun'><img height={100} className='logolen' src={productos[2].img}/></a> 
                  
                </div>
            </div>
        </header>
        </div>
    )
}

export default LensunHeader